var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.19v5l3.333 1.667m5-1.667a8.333 8.333 0 11-16.666 0 8.333 8.333 0 0116.666 0z",
    stroke: "#696969",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAyMCAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuOTk5OTkgNC4xOTAzOVY5LjE5MDM5TDEzLjMzMzMgMTAuODU3MU0xOC4zMzMzIDkuMTkwMzlDMTguMzMzMyAxMy43OTI4IDE0LjYwMjQgMTcuNTIzNyA5Ljk5OTk5IDE3LjUyMzdDNS4zOTc2MiAxNy41MjM3IDEuNjY2NjYgMTMuNzkyOCAxLjY2NjY2IDkuMTkwMzlDMS42NjY2NiA0LjU4ODAyIDUuMzk3NjIgMC44NTcwNTYgOS45OTk5OSAwLjg1NzA1NkMxNC42MDI0IDAuODU3MDU2IDE4LjMzMzMgNC41ODgwMiAxOC4zMzMzIDkuMTkwMzlaIiBzdHJva2U9IiM2OTY5NjkiIHN0cm9rZS13aWR0aD0iMS42NjY2NyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgTime as ReactComponent };